import React from "react";
import "./PopUp.scss";
import image from "../../resources/img/newsletter-sign-up@2x.jpg";

const STORAGE_KEY = "newsletter_popup_seen_v1";

class PopUp extends React.Component {
    state = { open: false };

    componentDidMount() {
        // show only if not seen before
        const seen = window.localStorage.getItem(STORAGE_KEY);
        if (!seen) this.setState({ open: true });
    }

    close = () => {
        window.localStorage.setItem(STORAGE_KEY, "1");
        this.setState({ open: false });
    };

    onSignUpClick = () => {
        // mark as seen when they click signup too
        window.localStorage.setItem(STORAGE_KEY, "1");
    };

    render() {
        if (!this.state.open) return null;

        return (
            <div className="fb_popup-overlay">
                <div className="fb_disclaimer-wrappers fb_shop-popups">
                    <button
                        className="fb_close-button"
                        aria-label="Close"
                        type="button"
                        onClick={this.close}
                    >
                        <svg className="close-icon" width="15" height="15" viewBox="0 0 15 15" aria-hidden="true">
                            <line x1="1" y1="1" x2="14" y2="14" />
                            <line x1="14" y1="1" x2="1" y2="14" />
                        </svg>
                    </button>

                    <div className="fb_popup-grid">
                        <div className="fb_popup-content">
                            <div className="fb_body-box">
                                <h1>
                                    Join the <strong>LIVE <i>large</i></strong>
                                    <br />
                                    family and save 15%
                                </h1>

                                <p>
                                    Sign up for news, competitions, and exclusive offers – and get
                                    15% off your wine purchase when you join. By subscribing, you
                                    confirm you’re of legal drinking age.
                                </p>

                                <a
                                    href="/sign-up"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="btn purple"
                                    onClick={this.onSignUpClick}
                                    style={{
                                        width: "100%",
                                        height: "40px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: "16px",
                                        fontWeight: "lighter",
                                    }}
                                >
                                    SIGN UP
                                </a>
                            </div>
                        </div>

                        <div className="fb_popup-image">
                            <img src={image} alt="" />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PopUp;
